export const afirmacoesHabilitadas = (destinacao: string | null | undefined): boolean => destinacao !== "inexistente";

export function respostasConformeDestinacao<T extends { resposta: boolean }>(respostas: T[], destinacao: string | null | undefined): T[] {
  return afirmacoesHabilitadas(destinacao) ? respostas : respostas.map((resposta) =>
    resposta.resposta ? { ...resposta, resposta: false } : resposta);
}

type PecaDestinacao = { destinacao: string | null; fotoUrl: string | null };

/** D6: com módulo desligado, peça sem foto chega como Inexistente. */
export const destinacaoSugeridaParceiro = (peca: PecaDestinacao, modulo: boolean): string | null =>
  peca.destinacao ?? (!modulo && !peca.fotoUrl ? "inexistente" : null);

/** O diálogo do RT exige um valor; módulo ligado não presume Inexistente. */
export const destinacaoInicialRt = (peca: PecaDestinacao, modulo: boolean): string =>
  peca.destinacao ?? (!modulo && !peca.fotoUrl ? "inexistente" : "venda_imediata");

export function bloqueioDestinacao(
  perfil: { empresaId?: string | null; roles?: string[] | null; userId?: string | null },
  laudo: { status: string; parceiroId: string; vistoriadoraId: string; tecnicoVistoriaId: string | null },
): "sem_permissao" | "assinado" | "finalizado" | "em_vistoria" | null {
  const roles = perfil.roles ?? [];
  const owner = roles.includes("owner");
  const equipe = !!perfil.empresaId && perfil.empresaId === laudo.vistoriadoraId &&
    (roles.includes("admin") || roles.includes("rt") || (!!perfil.userId && perfil.userId === laudo.tecnicoVistoriaId));
  const parceiro = !!perfil.empresaId && perfil.empresaId === laudo.parceiroId;
  if (!owner && !equipe && !parceiro) return "sem_permissao";
  if (laudo.status === "assinado") return "assinado";
  if (laudo.status === "finalizado") return "finalizado";
  if (!owner && !equipe && laudo.status !== "rascunho" && laudo.status !== "enviado_analise") return "em_vistoria";
  return null;
}
